export default "__VITE_ASSET__DUc8ZdPY__"